module.exports = __webpack_public_path__ + "img/home_banner_2.eddf7709.png";